window.Reverb = window.Reverb || {};

Reverb.Video = (function () {
  function bindYoutubeLink() {
    $('.youtube-link').fancybox({
      maxWidth: 800,
      maxHeight: 600,
      fitToView: false,
      width: '70%',
      height: '70%',
      autoSize: false,
      closeClick: false,
      openEffect: 'none',
      closeEffect: 'none',
      type: 'iframe',
    });
  }

  function init() {
    bindYoutubeLink();
  }

  return {
    init,
  };
}());

$(() => {
  Reverb.Video.init();
});



// WEBPACK FOOTER //
// ./src/components/legacy/video.js